import React, { useState, useEffect } from 'react';
import Banner from './Banner'
import Video from './Video'
import Review from './Review'
import Plan from './Plan'
import Bonus from './Bonus'
import Brainer from './Brainer'
import Helpbot from './Helpbot'
import ServiceTech from './ServiceTech'
import StepPart from './StepPart'

const HomeCopy = () => {
  const [showContent, setShowContent] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 0);

    return () => clearTimeout(timer);
  }, []);
  return (
    <>
      {showContent && (
        <>
          <Banner />
          <ServiceTech />
          <StepPart />
          <Video />
          <Review />
          <Plan />
          <Bonus />
          <Brainer />
          <Helpbot />
        </>
      )}
    </>
  )
}

export default HomeCopy
